export interface GAClientConfig {
  name: string;
}
